/* @usb-shield/components-react-versioned v2.0.0 © 2022 U.S. Bank - UXTechnology */
import React from 'react';
import PropTypes from 'prop-types';
import { USBIcon } from '@usb-shield/react-icons';

function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}

function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}

PropTypes.oneOfType([PropTypes.string,PropTypes.func,PropTypes.shape({current:PropTypes.any})]);PropTypes.oneOfType([PropTypes.node,PropTypes.func,PropTypes.string,PropTypes.shape({$$typeof:PropTypes.symbol,render:PropTypes.func}),PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func,PropTypes.string,PropTypes.shape({$$typeof:PropTypes.symbol,render:PropTypes.func})]))]);var getFormattedDataProps=function getFormattedDataProps(dataProps){var dataAttributes={};if(!(Object.keys(dataProps).length===0&&dataProps.constructor===Object)){Object.keys(dataProps).map(function(item){dataAttributes["data-".concat(item)]=dataProps[item];});}return dataAttributes;};/*Needed in  SSR*/(typeof window==="undefined"?"undefined":_typeof(window))==='object';

var name$2 = "@usb-shield/react-button";
var version$2 = "1.1.2";

var name$1 = "@usb-shield/components-react-versioned";
var version$1 = "2.0.0";
var description = "Shield Design System - React Components - Versioned";
var author = "U.S. Bank - UXTechnology";
var license = "MIT";
var repository = {
	type: "git",
	url: "git+https://gitlab.us.bank-dns.com/SHIELD/shield-components-react-v2.git"
};
var scripts = {
	"clean:install": "rm -rf node_modules && rm -rf package-lock.json && npm i && npm i --package-lock-only",
	commit: "npx git-cz && npx git push",
	dist: "npm run dist:icons && npm run dist:components && npm run dist:themes",
	"dist:components": "lerna run compile --stream --ignore @usb-shield/themes --ignore @usb-shield/react-all",
	"dist:themes": "node scripts/create-theme-css.js",
	"dist:beta-themes": "node scripts/beta-create-css.js",
	"dist:beta": "npm run dist:components && npm run dist:beta-themes",
	"dist:icons": "node scripts/process-icons.js",
	"dist:all": "lerna run compile --stream --scope @usb-shield/react-all",
	"lint:check": "eslint ./packages",
	"lint:fix": "eslint ./packages --fix",
	"prettier:check": "npx prettier --check ./packages",
	"prettier:fix": "npx prettier -write ./packages",
	"postdist:icons": "eslint ./packages/icons/src/icons/ --fix",
	test: "jest --config ./jest.config.json -w 1 --coverage --no-cache",
	"e2e:dev": "testcafe chrome endToEndTests/tests/*.test.js --speed 0.5 --proxy web-proxyosx.us.bank-dns.com:3128 --proxy-bypass shield-test.us.bank-dns.com/dev/shield-components --reporter html:endToEndTests/reports/index.html",
	"e2e:prod": "./node_modules/.bin/testcafe chromium:headless endToEndTests/tests/*.test.js --proxy web-proxyosx.us.bank-dns.com:3128 --proxy-bypass shield-test.us.bank-dns.com/dev/shield-components -r xunit:endToEndTests/reports/test-report.xml",
	"test:watch": "jest --config ./jest.config.json --watchAll",
	sb: "start-storybook -p 6006",
	"sb:build": "build-storybook",
	browserslist: "npx browserslist",
	"release-version": "lerna version --yes --conventional-commits --create-release gitlab",
	release: "lerna publish from-git --yes",
	"release:all": "lerna publish --force-publish @usb-shield/react-all --ignore-changes '**' --yes",
	"release-version-beta": "lerna version --yes --conventional-prerelease --preid beta --create-release gitlab",
	"release-beta": "lerna publish from-git --yes --dist-tag beta",
	generate: "plop --plopfile generators/index.js",
	"new-demo": "node scripts/new-demo.js --name $DEMO",
	"demo:install": "npm install && cd ./sandbox && npm run dev:install",
	demo: "cd ./sandbox && npm run dev:shielddev",
	postinstall: "node scripts/post-install.js",
	prepare: "husky install"
};
var husky = {
	hooks: {
		"commit-msg": "commitlint -E HUSKY_GIT_PARAMS",
		"pre-commit": "lint-staged --relative && npm test"
	}
};
var commitlint = {
	"extends": [
		"@commitlint/config-angular"
	]
};
var config = {
	commitizen: {
		path: "commitiquette"
	}
};
var devDependencies = {
	"@babel/core": "^7.17.5",
	"@babel/eslint-parser": "^7.17.0",
	"@babel/eslint-plugin": "^7.16.5",
	"@babel/plugin-transform-runtime": "^7.17.0",
	"@babel/preset-env": "^7.16.11",
	"@babel/preset-react": "^7.16.7",
	"@commitlint/cli": "^16.2.1",
	"@commitlint/config-angular": "^16.2.1",
	"@csstools/postcss-sass": "^4.0.0",
	"@rollup/plugin-alias": "^3.1.9",
	"@rollup/plugin-commonjs": "^21.0.1",
	"@rollup/plugin-json": "^4.1.0",
	"@rollup/plugin-node-resolve": "^13.1.3",
	"@rollup/plugin-replace": "^3.1.0",
	"@sambego/storybook-state": "^2.0.1",
	"@storybook/addon-actions": "^6.4.14",
	"@storybook/addon-docs": "^6.4.19",
	"@storybook/addon-essentials": "^6.4.19",
	"@storybook/addon-links": "^6.4.19",
	"@storybook/addons": "^6.4.19",
	"@storybook/preset-scss": "^1.0.3",
	"@storybook/react": "^6.4.19",
	"@testing-library/jest-dom": "^5.16.2",
	"@testing-library/react": "^12.1.3",
	"@testing-library/user-event": "^13.5.0",
	"@usb-shield/design-tokens": "latest",
	"@wojtekmaj/enzyme-adapter-react-17": "^0.6.6",
	"babel-plugin-react-remove-properties": "^0.3.0",
	"babel-plugin-transform-react-remove-prop-types": "^0.4.24",
	colorette: "^2.0.16",
	commitiquette: "^1.2.1",
	commitizen: "^4.2.4",
	"core-js": "^3.21.1",
	"cross-env": "^7.0.3",
	cssnano: "^4.1.10",
	"cz-lerna-changelog": "^2.0.3",
	dayjs: "^1.10.7",
	del: "^6.0.0",
	enzyme: "^3.11.0",
	"enzyme-to-json": "^3.6.2",
	eslint: "^8.9.0",
	"eslint-config-prettier": "^8.4.0",
	"eslint-plugin-babel": "^5.3.1",
	"eslint-plugin-jest": "^26.1.1",
	"eslint-plugin-jsx-a11y": "^6.5.1",
	"eslint-plugin-react": "^7.28.0",
	"eslint-plugin-react-hooks": "^4.3.0",
	"fs-extra": "^10.0.0",
	glob: "^7.2.0",
	husky: "^7.0.0",
	jest: "^26.6.2",
	"jest-axe": "^5.0.1",
	lerna: "^4.0.0",
	"lint-staged": "^9.5.0",
	"make-dir": "^3.1.0",
	minimist: "^1.2.5",
	path: "^0.12.7",
	plop: "^3.0.5",
	"postcss-gap-properties": "^2.0.0",
	"postcss-import": "^12.0.1",
	"postcss-load-config": "^2.1.0",
	"postcss-preset-env": "^6.7.0",
	"postcss-pxtorem": "^4.0.1",
	"postcss-reporter": "^6.0.1",
	"postcss-scss": "^2.0.0",
	"postcss-url": "^8.0.0",
	prettier: "2.5.1",
	"prop-types": "^15.8.1",
	react: "^17.0.2",
	"react-dom": "^17.0.2",
	"react-test-renderer": "^17.0.2",
	"react-transition-group": "^4.4.2",
	"replace-in-file": "^6.3.2",
	rollup: "^2.62.0",
	"rollup-plugin-babel": "^4.4.0",
	"rollup-plugin-cjs-es": "^1.0.1",
	"rollup-plugin-clear": "^2.0.7",
	"rollup-plugin-peer-deps-external": "^2.2.4",
	"rollup-plugin-postcss": "^2.5.0",
	"rollup-plugin-sass": "^1.2.10",
	"rollup-plugin-terser": "^7.0.2",
	"sass-loader": "^10.0.0",
	testcafe: "^1.18.4",
	"testcafe-reporter-html": "^1.4.6",
	xml2js: "^0.4.23",
	yarpm: "^1.1.1"
};
var peerDependencies = {
	"prop-types": "^15.8.1",
	react: "~16.13.1",
	"react-dom": "~16.13.1"
};
var dependencies = {
	"@mdx-js/react": "^1.6.22",
	"@types/react": "^17.0.39",
	classnames: "^2.3.1",
	"jest-sonar-reporter": "^2.0.0",
	sass: "^1.43.4"
};
var require$$0 = {
	name: name$1,
	version: version$1,
	description: description,
	author: author,
	license: license,
	repository: repository,
	scripts: scripts,
	husky: husky,
	commitlint: commitlint,
	"lint-staged": {
	"packages/**/*.js": [
		"eslint --fix",
		"prettier --write",
		"git add",
		"jest --findRelatedTests --coverage --no-cache --bail"
	]
},
	config: config,
	devDependencies: devDependencies,
	peerDependencies: peerDependencies,
	dependencies: dependencies
};

var _require=require$$0,name=_require.name,version=_require.version;var analyticsData={libraryName:name.split('/')[0],libraryVersion:version};var libraryName = analyticsData.libraryName;var libraryVersion = analyticsData.libraryVersion;

/**
 * Button
 *
 * @param {String} id - id attribute
 * @param {String} name - Name attribute
 * @param {String} value - Value attribute
 * @param {String} addClasses - Class name for styling
 * @param {String} variant - The variant (loud, primary, secondary, utility, text ).
 * @param {String} type - The HTML5 button type (Button, Submit, Reset).
 * @param {String} size - Small, Default or Large.
 * @param {Boolean} ariaHidden - Becomes the ID of the input and htmlFor attribute of the label
 * @param {String} title - custom title.
 * @param {Object} iconAssistiveText - Assistive text for accessibility.
 * @param {String} iconViewBox - Viewbox size for icon.
 * @param {(Object|Array)} iconData - Icon SVG data.
 * @param {String} iconSize - Set icon size.
 * @param {Function} [handleClick] - An onClick handler.
 * @param {Function} [forwardedRef] - The ref from a parent component.
 * @param {String} ariaLabel - Optional offscreen label for a11y.
 * @param {Element} children - The button text.
 * @param {Boolean} disabled - Optional disabled prop.
 * @param {String} dataTestId - dataTestId holds unique test id
 * @param {Object} spacing - spacing to control margin and padding
 * @param {Object} addProps - additional Props
 * @param {Object} dataProps - key/value pairs for data attributes; 'data-' gets prepended using getFormattedDataProps util
 *
 *
 * @returns {HTMLElement}
 */var USBButton=function USBButton(_ref){var id=_ref.id,name=_ref.name,addClasses=_ref.addClasses,variant=_ref.variant,type=_ref.type,size=_ref.size,ariaHidden=_ref.ariaHidden,title=_ref.title,iconAssistiveText=_ref.iconAssistiveText,iconViewBox=_ref.iconViewBox,iconData=_ref.iconData,iconSize=_ref.iconSize,forwardedRef=_ref.forwardedRef,handleClick=_ref.handleClick,ariaLabel=_ref.ariaLabel,children=_ref.children,disabled=_ref.disabled,value=_ref.value,dataTestId=_ref.dataTestId,iconColor=_ref.iconColor,spacing=_ref.spacing,addProps=_ref.addProps,dataProps=_ref.dataProps;var dataAttributes=getFormattedDataProps(dataProps);var iconName=title?title:'icon-sys-add';return/*#__PURE__*/React.createElement("button",_extends({"data-compn":name$2,"data-compv":version$2,"data-libn":libraryName,"data-libv":libraryVersion,ref:forwardedRef,id:id,className:"usb-button button--".concat(variant," button--").concat(size," ").concat(addClasses),name:name,type:type,"aria-label":ariaLabel?ariaLabel:null,onClick:handleClick,disabled:disabled,value:value?value:null,style:{margin:spacing&&spacing.margin&&spacing.margin,padding:spacing&&spacing.padding&&spacing.padding},"data-testid":dataTestId?dataTestId:null},dataAttributes,addProps),iconData!==null?/*#__PURE__*/React.createElement(USBIcon,{assistiveText:iconAssistiveText,ariaHidden:ariaHidden,colorVariant:iconColor,size:iconSize,viewBox:iconViewBox,title:iconName,xmlns:"http://www.w3.org/2000/svg",data:iconData}):iconData,children);};USBButton.defaultProps={id:'',name:'',addClasses:'',variant:'text',type:'button',size:'default',ariaHidden:true,title:'',iconAssistiveText:{},iconViewBox:'',iconData:null,iconSize:'16',ariaLabel:null,forwardedRef:null,handleClick:null,children:null,disabled:false,value:null,dataTestId:'',iconColor:'default',spacing:null,addProps:null,dataProps:{}};

export { USBButton as default };
